/**
 * Created by JackCui on 2021/12/2
 */

export default function headerSchemaHandle ({title, apiName}) {
  return {
    _type: 'header',
    viewComponentName: 'header',
    props: {title},
    apiName
  }
}

export const headerProps = {
  // 头部title
  title: '',
  // 是否吸顶
  positionCeiling: {
    type: Boolean,
    default: false
  },
  // 吸顶定位高度
  ceilingHeight: {
    type: Number,
    default: 0
  },
  // 是否需要面包屑
  isCrumbs: {
    type: Boolean,
    default: false
  },
  // 面包屑数据  面包屑内的数据格式  name(页面名) url(跳转页面路径)
  crumbsData: {
    type: Array,
    default: () => []
  },
  // 返回自定义方法
  customFun: {
    type: Function,
    default: ''
  },
  // 页面类型
  pageType: {
    type: String,
    default: ''
  }
}
